import React from "react";

const AccountContext = React.createContext({ id: "", name: "", admin: "" });

export default AccountContext;



// WEBPACK FOOTER //
// ./src/utils/AccountContext.js